/**
 * introduced in FS Baseball 2022 if property not available then if data.scoring exists = origin StatGrab, as FS Baseball 2021 did not sent scoring
 * 2021 version of FS Baseball and FS StatGrab, JS at web does not know this, update in progress
 * @see https://bitbucket.org/flightscope/dto-schema/src/1c26e3e4cf94bd6c852b58bbbd27d79ffdca3d4b/baseball/entity/result-v2.json#lines-93
 */
const ScoringType = {
    StatGrab:         { key: 'StatGrab',        name: 'StatGrab' },
    extendedTagging:  { key: 'extendedTagging', name: 'Extended Tagging' },
};

export default ScoringType;